import React,{Component} from "react";
import "./header/Header.css";
import "../scss/general.css";
import logo from "./images/loading.gif";
import Cookies from "universal-cookie";
import logonotfound from './images/recordnotfound.png';

//import config from '../config';
//import logonorecord from "./images/recordnotfound.png";

const cookies = new Cookies();
export default class Texcertificate extends Component {
    constructor(props) {
        super();
        this.state={
        ErrMsg:<img src={logonotfound} alt="Error"/>,
        emp_id:cookies.get("LoginID")+".pdf",
        today: new Date(),
        DivClass: "ErrDiv"
        }}
        componentDidMount(){
        }
render(){
    let filename="http://poultry-kandns.com/images/"+this.state.emp_id;
    return(
    <div className="container1">

 <object data={filename} type="application/pdf" style={{width:"95%", height:"100%",marginLeft:"5%"}}>
     <div className="inner-profile">
        <h3 style={{textAlign:"center",width:"100%",paddingTop:"100px"}}>Sorry, File not found...</h3>        
      </div>
    </object>
</div>
);
}
}

